import { z } from "zod";

export const clientRoleSchema = z.enum(["visuals", "admin"]);
export type ClientRole = z.infer<typeof clientRoleSchema>;

/**
 * No client message can mutate show state. Spawning, config and reset are REST only,
 * so auth, rate limiting, idempotency and audit all live in one place.
 */
export const clientMessageSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("hello"),
    protocolVersion: z.number().int(),
    role: clientRoleSchema,
    /** Stable per browser profile; makes venue logs readable. */
    clientId: z.string().uuid(),
    /** Last seq this client applied. Informational today; the hook for future deltas. */
    lastSeq: z.number().int().nonnegative().optional(),
    /** Lets the server log "this client survived a restart" explicitly. */
    lastServerSessionId: z.string().uuid().optional(),
  }),

  z.object({ type: z.literal("pong"), t: z.number().int() }),

  z.object({ type: z.literal("resync_request"), reason: z.string().max(200) }),

  /** Venue telemetry from the projection PC. Logged, never acted on. */
  z.object({
    type: z.literal("client_stats"),
    fps: z.number(),
    particles: z.number().int(),
    droppedFrames: z.number().int(),
  }),
]);
export type ClientMessage = z.infer<typeof clientMessageSchema>;
export type ClientMessageOf<T extends ClientMessage["type"]> = Extract<ClientMessage, { type: T }>;
